import React from "react";
// MUI
import { Grid2 } from "@mui/material";
// Styling
import styles from "./SiteDetails.module.scss";
// Local imports
import CustomInput from "../CustomInput/CustomInput";
import { verifyPassword } from "../../Utils/utils";

export default function SiteDetails(props) {
  const {
    wpAdmin,
    setWpAdmin,
    hasImportantDirs,
    isCurrentHosting,
  } = props;

  const fromFieldUpdate = (value, type) => {
    if (type === "WP-Admin URL") {
      const startsWithNonDigit = /^[^0-9]/;
      if (value !== "" && !startsWithNonDigit.test(value)) {
        return;
      }
      // value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      const regExForNumberNotInStart = /^[^0-9]/;
      if (value.length <= 3 && regExForNumberNotInStart.test(value)) {
        setWpAdmin({
          ...wpAdmin,
          wpadminurlerror: false,
          wpadminurl: value.toLowerCase().trim(),
        });
      } else {
        setWpAdmin({
          ...wpAdmin,
          wpadminurlerror: false,
          wpadminurl: value.toLowerCase().trim(),
        });
      }
    } else if (type === "WP-Admin Username") {
      setWpAdmin({
        ...wpAdmin,
        wpadminusernameerror: false,
        wpadminusername: value.toLowerCase().trim(),
      });
    } else if (type === "WP-Admin Password") {
      if (!verifyPassword(value)) {
        setWpAdmin({
          ...wpAdmin,
          wpadminpassworderror: true,
          wpadminpassword: value,
        });
      } else {
        setWpAdmin({
          ...wpAdmin,
          wpadminpassworderror: false,
          wpadminpassword: value,
        });
      }
    }
  };

  return (
    <>
      {isCurrentHosting &&
        ((hasImportantDirs === true &&
          isCurrentHosting.specifydirectory !== "") ||
          (isCurrentHosting.currenthosting !== "" &&
            hasImportantDirs === false)) && (
          <Grid2 className={styles.SiteDetails}>
            <Grid2 className={styles.header}>Site Details</Grid2>
            <Grid2 className={styles.MigrationFlexBox}>
              <CustomInput
                title={"WP-Admin URL"}
                placeholder={"Enter Url"}
                value={wpAdmin?.wpadminurl}
                setValue={(e, name) => {
                  fromFieldUpdate(e, name);
                }}
                suffix={wpAdmin.wpadminurlsuffix}
                error={wpAdmin.wpadminurlerror}
              />
              <CustomInput
                title={"WP-Admin Username"}
                placeholder={"Enter Username Or Email Id"}
                value={wpAdmin.wpadminusername}
                setValue={(e, name) => {
                  fromFieldUpdate(e, name);
                }}
                error={wpAdmin.wpadminusernameerror}
              />
              <CustomInput
                title={"WP-Admin Password"}
                placeholder={"Enter Wp-Admin Password "}
                value={wpAdmin.wpadminpassword}
                setValue={(e, name) => {
                  fromFieldUpdate(e, name);
                }}
                password={true}
                passwordview={true}
                autocomplete={"off"}
                required={true}
              />
            </Grid2>
          </Grid2>
        )}
    </>
  );
}
